/**
 * TextInput — bottom-border style. Goes inside a `<Field>` slot.
 * Mono 16 px on transparent background. The visible border is owned by Field;
 * the input itself is borderless.
 * Source: .agents/design/project/artboard-radical-zakaznik-form.jsx:188-203
 */

import type { InputHTMLAttributes, Ref, ReactNode } from 'react';

interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  type?: 'text' | 'email' | 'tel' | 'url' | 'number' | 'search' | 'password' | 'date' | 'datetime-local';
  /** Trailing unit (e.g. "Kč", "km"). */
  suffix?: ReactNode;
  ref?: Ref<HTMLInputElement>;
}

export function TextInput({
  type = 'text',
  suffix,
  className = '',
  ref,
  ...rest
}: TextInputProps) {
  return (
    <>
      <input
        {...rest}
        ref={ref}
        type={type}
        className={
          'min-w-0 flex-1 border-0 bg-transparent py-1 font-mono text-[16px] tracking-[-0.01em] text-ink outline-none placeholder:italic placeholder:text-ink-3/55 ' +
          className
        }
      />
      {suffix && (
        <span className="pl-2 font-mono text-[11px] text-ink-3">{suffix}</span>
      )}
    </>
  );
}
